import { createApp } from "vue";
import App from "./App.vue";
import VueDatePicker from "@vuepic/vue-datepicker";
import { createPinia } from "pinia";
import "@vuepic/vue-datepicker/dist/main.css";
import i18n from "./i18n/setup";

import {
  plugin as fkPlugin,
  config as fkConfig,
} from "./plugins/formkit/formKit.config";
import { addSpaStaticsToHead } from "./utils/spa-statics";

addSpaStaticsToHead();

const app = createApp(App);

app.use(createPinia());
app.use(fkPlugin, fkConfig);
app.use(i18n);
app.component("VueDatePicker", VueDatePicker);

app.mount("#app-search");
